import { GetterTree } from 'vuex';
import { IInputControl } from './Interfaces';
import { IRootState } from '../../store';

export const getters: GetterTree<IInputControl, IRootState> = {
    inputControlDocuments: (state) => state.inputControlDocuments.filter((item) => item.documentsQuality.length),
    inputControlDocumentsNoQualityDocs: (state) => state.inputControlDocuments.filter((item) => !item.documentsQuality.length),
    inputControlLoaded: (state) => state.inputControlLoaded,
};
